(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("borderless-light", [], factory);
	else if(typeof exports === 'object')
		exports["borderless-light"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["BorderlessLight"] = factory();
})(this, () => {
return 